import { Controller } from "@hotwired/stimulus"

// Makes an appointment card draggable via native HTML5 drag-and-drop.
// Records the grab offset (cursor-to-card-top distance at drag start) so the
// drop zone can compute time based on where the card's TOP edge lands, not
// where the cursor is. Without this, time is off by however far down the user
// grabs the card (e.g. grabbing the middle of a 60-min card → 30-min error).

export default class extends Controller {
  static values = {
    appointmentId: Number,
    duration: Number,
  }

  connect() {
    this.element.setAttribute("draggable", "true")
    this.element.addEventListener("dragstart", this.dragstart)
    this.element.addEventListener("dragend", this.dragend)
    this._dropHandled = false
  }

  disconnect() {
    this.element.removeAttribute("draggable")
    this.element.removeEventListener("dragstart", this.dragstart)
    this.element.removeEventListener("dragend", this.dragend)
  }

  dragstart = (e) => {
    if (!this.appointmentIdValue) return

    const cardRect = this.element.getBoundingClientRect()
    const grabOffsetY = e.clientY - cardRect.top

    const payload = {
      appointmentId: this.appointmentIdValue,
      grabOffsetY,
    }
    if (this.hasDurationValue) payload.durationMinutes = this.durationValue

    e.dataTransfer.setData("application/json", JSON.stringify(payload))
    e.dataTransfer.effectAllowed = "move"
    e.dataTransfer.setData("text/plain", String(this.appointmentIdValue))

    this._dropHandled = false

    // Hide the original element AFTER the browser captures the ghost image.
    // requestAnimationFrame ensures the ghost is created from the visible element.
    requestAnimationFrame(() => {
      this.element.style.opacity = "0"
      this.element.style.pointerEvents = "none"
    })
  }

  dragend = () => {
    // If a valid drop zone handled this card, it manages visibility.
    // Otherwise (cancelled drag / dropped outside a zone), restore here.
    if (!this._dropHandled) {
      this.element.style.opacity = ""
      this.element.style.pointerEvents = ""
    }
  }

  markHandled() {
    this._dropHandled = true
  }
}
